import { CrossTableVue } from './crossTableVue'

export const CrossTable = (() => {
	const crossTableVue = CrossTableVue()
	const init = () => {
		crossTableVue.init()
	}

	return {
		init,
	}
})()
